<template>
  <rest-list-page
    :page-title="pageTitle"
    :fetch-endpoint="fetchEndpoint"
    ref="rest-list-page"
  >
    <template slot="table">
      <rest-list-column-date
        prop="create_time"
        :title="$t('TaskHistoryList_Field_CreateTime')"
        :width="200"
      />

      <rest-list-column-enum
        prop="identifier"
        :title="$t('TaskHistoryList_Field_Identifier')"
        :enum="identifierLabel"
        :select-search="true"
      />

      <rest-list-column prop="info" :title="$t('TaskHistoryList_Field_Info')" />

      <rest-list-column
        v-if="$hasFeature('featureAutomationCampaignExecution')"
        prop="triggered_campaign_id"
        :sortable="false"
        :title="$t('TaskHistoryList_Field_TriggeredCampaignID')"
        :width="180"
      >
        <template slot-scope="scope">
          <router-link
            :to="rowViewCampaign(scope.row)"
            target="_blank"
            v-if="scope.row.triggeredCampaignId"
          >
            {{ scope.row.triggeredCampaignId }}
          </router-link>
          <span v-else>-</span>
        </template>
      </rest-list-column>

      <rest-list-column-enum
        prop="status"
        :title="$t('TaskHistoryList_Field_Status')"
        :enum="statusLabel"
        :width="200"
      />

      <rest-list-column-actions>
        <template slot-scope="scope">
          <rest-list-action-view :route="rowViewRoute(scope.row)" />
          <rest-list-action
            v-if="canCancelTask(scope.row)"
            icon="el-icon-circle-close"
            :title="$t('RestList_Action_Cancel')"
            :click="
              () =>
                rowCancel(scope.row, $t(identifierLabel[scope.row.identifier]))
            "
          />
          <rest-list-action-delete
            v-if="canDeleteTask(scope.row)"
            :endpoint="rowDeleteEndpoint(scope.row)"
            :name="$t(identifierLabel[scope.row.identifier])"
          />
        </template>
      </rest-list-column-actions>
    </template>
  </rest-list-page>
</template>

<script>
import RestApi from '@/core/services/RestApi'
import RestListPage from '@/common/components/rest/RestListPage'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnEnum from '@/common/components/rest/RestListColumnEnum'
import RestListColumnDate from '@/common/components/rest/RestListColumnDate'
import RestListAction from '@/common/components/rest/RestListAction'
import RestListActionView from '@/common/components/rest/RestListActionView'
import RestListActionDelete from '@/common/components/rest/RestListActionDelete'
import RestListColumnActions from '@/common/components/rest/RestListColumnActions'
import {
  taskStatusEnum as statusEnum,
  taskIdentifierLabel as identifierLabel,
  taskStatusLabel as statusLabel
} from '@/modules/tasks/enum/TaskRecordEnums'
import { projectEndpoint, projectRoute } from '@/core/helpers'

export default {
  components: {
    RestListPage,
    RestListColumn,
    RestListColumnEnum,
    RestListColumnDate,
    RestListColumnActions,
    RestListAction,
    RestListActionView,
    RestListActionDelete
  },

  data() {
    return {
      statusEnum,
      identifierLabel,
      statusLabel
    }
  },

  mounted() {
    if (this.$route.query.ids) {
      this.refreshInterval = setInterval(() => {
        this.$refs['rest-list-page'].refresh()
      }, 2500)
    }
  },

  destroyed() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval)
    }
  },

  computed: {
    pageTitle() {
      return this.$t(this.$route.meta.title)
    },

    fetchEndpoint() {
      let endpointParams = {
        sort: '-id',
        id: this.$route.query.ids
      }

      if (this.$hasFeature('featureAutomationCampaignExecution')) {
        endpointParams.expand = 'triggeredCampaignId'
      }

      return projectEndpoint({
        method: 'get',
        url: `task-histories`,
        params: endpointParams
      })
    }
  },

  methods: {
    rowViewRoute(row) {
      return projectRoute({
        name: 'TaskHistoryView',
        query: { id: row.id }
      })
    },

    rowDeleteEndpoint(row) {
      return projectEndpoint({
        method: 'delete',
        url: `task-histories/${row.id}`
      })
    },

    async rowCancel(row, name) {
      this.$msgbox({
        title: this.$t('RestList_CancelTitle'),
        message: this.$t('RestList_CancelPrompt', {
          label: this.$t(identifierLabel[row.identifier])
        }),
        showCancelButton: true,
        confirmButtonText: this.$t('RestList_CancelConfirmButton'),
        cancelButtonText: this.$t('RestList_CancelCancelButton'),
        center: true,
        dangerouslyUseHTMLString: this.htmlWarningMsg
      }).then(() => {
        RestApi(
          projectEndpoint({
            method: 'patch',
            url: `task-histories/${row.id}`,
            data: { status: statusEnum.CANCELLED }
          })
        )
          .then(() => {
            this.$message({
              message: this.$t('RestList_CancelSuccessMessage'),
              type: 'success'
            })
            this.$refs['rest-list-page'].refresh()
          })
          .catch(error => {
            this.$message({
              message: error.message,
              type: 'error'
            })
          })
      })
    },

    rowViewCampaign(row) {
      return projectRoute({
        name: 'ViewCampaign',
        query: { id: row.triggeredCampaignId }
      })
    },

    canDeleteTask(row) {
      return this.$isRole('admin') && row.status === statusEnum.NEW
    },

    canCancelTask(row) {
      return row.status === statusEnum.NEW
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/tasks/pages/TaskListPage.vue